import { gsap } from 'gsap';

export default () => {
  const p = ModuleTab.prototype;

  function ModuleTab(){
    this.tabs = [];
    this.init();
  }

  p.init = function(){
    this.handleEvents();
  };

  p.handleEvents = function(){
    // DOMContentLoadedイベントでタブを初期化
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', this.initializeTabs.bind(this));
    } else {
      this.initializeTabs();
    }
  };

  p.initializeTabs = function(){
    const tabContainers = document.querySelectorAll('[data-tab]');
    
    tabContainers.forEach((container, containerIndex) => {
      const menuItems = container.querySelectorAll('[data-tab-menu]');
      const mainItems = container.querySelectorAll('[data-tab-main]');
      
      if (menuItems.length === 0 || mainItems.length === 0) return;
      
      // 最初のタブをアクティブにする
      menuItems[0].classList.add('is-active');
      mainItems[0].classList.add('is-active');
      gsap.set(mainItems[0], {y: 0, opacity: 1});
      
      // クリックイベントを追加
      menuItems.forEach((menuItem, menuIndex) => {
        menuItem.addEventListener('click', (e) => {
          e.preventDefault();
          this.switchTab(menuItems, mainItems, menuIndex);
        });
      });
    });
  };

  p.switchTab = function(menuItems, mainItems, targetIndex){
    // 全てのメニューとメインコンテンツからアクティブクラスを削除
    menuItems.forEach(item => item.classList.remove('is-active'));
    mainItems.forEach(item => item.classList.remove('is-active'));
    
    // ターゲットのメニューとメインコンテンツにアクティブクラスを追加
    menuItems[targetIndex].classList.add('is-active');
    mainItems[targetIndex].classList.add('is-active');
    
    // アニメーション
    gsap.fromTo(mainItems[targetIndex], {
      y: 10,
      opacity: 0
    }, {
      duration: 0.8,
      ease: 'power2.inOut',
      y: 0,
      opacity: 1,
      onComplete: () => {
        // タブ切り替え完了後にbefore afterスライダーを再初期化
        this.reinitializeBeforeAfterSliders();
      }
    });
  };

  p.reinitializeBeforeAfterSliders = function(){
    // before afterスライダーを再初期化
    if (typeof window.reinitializeBeforeAfterSliders === 'function') {
      window.reinitializeBeforeAfterSliders();
    }
  };

  new ModuleTab();
};